module.exports = __webpack_public_path__ + "img/28.0ff9641e.png";